import { FormikHelpers } from "formik";
import { TFunction } from "i18next";
import * as yup from "yup";
import { toastResponseError } from "../../../utils/responseMessageHelper";

export interface ShopifyProfileFormValues {
  store_name: string;
  api_secret_key: string;
  admin_api_access_token: string;
  location_id: string;
}

export const shopifyProfileFormHelper = (
  t: TFunction,
  submitAction: (data: any) => Promise<any>,
  closeRightPanel: () => void,
  initialValues?: ShopifyProfileFormValues,
) => ({
  enableReinitialize: true,
  validateOnChange: true,
  validateOnBlur: false,
  initialValues: initialValues || {
    store_name: "",
    api_secret_key: "",
    admin_api_access_token: "",
    location_id: "",
  },
  validationSchema: yup.object().shape({
    store_name: yup
      .string()
      .required(
        t("error.required", { field: t("shopify.storeName") }),
      ),
    api_secret_key: yup
      .string()
      .required(
        t("error.required", { field: t("shopify.apiSecretKey") }),
      ),
    admin_api_access_token: yup
      .string()
      .required(
        t("error.required", { field: t("shopify.adminApiAccessToken") }),
      ),
    location_id: yup
      .string()
      .required(
        t("error.required", { field: t("shopify.locationId") }),
      ),
  }),
  onSubmit: (
    values: ShopifyProfileFormValues,
    { setSubmitting }: FormikHelpers<ShopifyProfileFormValues>,
  ) => {
    submitAction({
      store_name: values.store_name,
      api_secret_key: values.api_secret_key,
      admin_api_access_token: values.admin_api_access_token,
      location_id: values.location_id,
    })
      .then(() => closeRightPanel())
      .catch((response: string) => {
        toastResponseError(response);
      })
      .finally(() => setSubmitting(false));
  },
});
